import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
import { getFallbackValueIfNull } from 'owa-options-core';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function isSignatureOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    return (optionState.editorViewState.isDirty ||
        getFallbackValueIfNull(optionState.signNewMails, userOptions.AutoAddSignature) !==
            userOptions.AutoAddSignature ||
        getFallbackValueIfNull(optionState.signReplies, userOptions.AutoAddSignatureOnReply) !==
            userOptions.AutoAddSignatureOnReply);
});
//# sourceMappingURL=isSignatureOptionDirty.js.map